<template>

<core-modal-setting title="Label" :value="value" placeholder="None">
        
    <core-input-textbox 
		:autofocus="true" 
		maxlength="16" 
		placeholder="Enter label" 
		v-model="internalValue"
	/>

</core-modal-setting>

</template>

<script>

import mixSetting from 'core/mixin/modal/Setting'

export default {

    mixins: [mixSetting]

}

</script>

<style scoped>

</style>